import React, { useEffect } from 'react';
import useMissionDialogStore from '@/shared/store/UseMissionDialogStore';
import { MissionSuccessDialog } from '@/widgets/app/dialog/MissionSuccessDialog';

/**
 * 전역 미션 성공 다이얼로그 매니저
 * - AppPage에 한번만 마운트하고, useMissionDialogStore().openMissionDialog(...)로 어디서든 호출한다
 */
export const MissionDialogManager: React.FC = () => {
  const { isOpen, payload, closeMissionDialog } = useMissionDialogStore();

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !payload) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 px-6">
      <MissionSuccessDialog
        title={payload.title}
        message={payload.message}
        points={payload.points}
        image={payload.image}
        confirmLabel={payload.confirmLabel}
        onConfirm={closeMissionDialog}
      />
    </div>
  );
};

export default MissionDialogManager;
